// src/services/planService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/plan" };

const normalizeStatus = (s) => {
  const v = String(s || "").toLowerCase();
  return v === "publish" ? "Publish" : "UnPublish";
};

export async function getAllPlans({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data;
}

export async function addPlan(
  {
    title,
    amount,      // string like "49.99"
    dayLimit,    // string like "30"
    description, // optional
    filterInclude,
    audioVideo,
    directChat,
    chat,
    likeMenu,
    status,
  },
  { signal } = {}
) {
  const body = {
    title,
    amount: String(amount ?? ""),
    dayLimit: String(dayLimit ?? ""),
    description: description ?? "",
    filterInclude: !!filterInclude,
    audioVideo: !!audioVideo,
    directChat: !!directChat,
    chat: !!chat,
    likeMenu: !!likeMenu,
    status: normalizeStatus(status),
  };
  const res = await apiClient.post(endpoints.base, body, { signal });
  return res.data;
}

// Send ONLY changed fields + id
export async function updatePlanPartial(
  {
    id,
    title,
    amount,
    dayLimit,
    description,
    filterInclude,
    audioVideo,
    directChat,
    chat,
    likeMenu,
    status,
  },
  { signal } = {}
) {
  if (!id) throw new Error("Plan id is required");
  const body = { id };
  if (typeof title !== "undefined") body.title = title;
  if (typeof amount !== "undefined") body.amount = String(amount);
  if (typeof dayLimit !== "undefined") body.dayLimit = String(dayLimit);
  if (typeof description !== "undefined") body.description = description ?? "";
  if (typeof filterInclude !== "undefined")
    body.filterInclude = !!filterInclude;
  if (typeof audioVideo !== "undefined") body.audioVideo = !!audioVideo;
  if (typeof directChat !== "undefined") body.directChat = !!directChat;
  if (typeof chat !== "undefined") body.chat = !!chat;
  if (typeof likeMenu !== "undefined") body.likeMenu = !!likeMenu;
  if (typeof status !== "undefined") body.status = normalizeStatus(status);

  const res = await apiClient.put(endpoints.base, body, { signal });
  return res.data;
}

export async function deletePlan({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
